package com.havn.app.core.platform

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

data class HavnMapCoordinate(
    val latitude: Double,
    val longitude: Double
)

@Composable
expect fun HavnPropertyMap(
    address: String,
    searchRequestId: Int,
    markerTitle: String,
    missingTokenMessage: String,
    loadingMessage: String,
    coordinate: HavnMapCoordinate?,
    onCoordinateChanged: (HavnMapCoordinate) -> Unit,
    modifier: Modifier = Modifier
)
